import styled from 'styled-components';
import { theme } from '@attain-sre/attain-design-system';

export const Wrapper = styled.div<{ $bothAxes: boolean }>`
  height: 300px;
  padding: 0 0 40px 40px;
  padding-inline-end: ${({ $bothAxes }) => ($bothAxes ? '40px' : '0')};
  position: relative;
`;

export const LegendLeft = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  translate: 0 calc(-50% - 24px);
`;

export const LegendRight = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  translate: 0 calc(-50% - 24px);
`;

export const LegendBottom = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  translate: -50% 0;
`;

export const ChartWrapper = styled.div<{
  $barOrientation: 'horizontal' | 'vertical';
  $bothAxes: boolean;
  $chartType: 'bar' | 'scatter';
}>`
  align-items: ${({ $barOrientation }) =>
    $barOrientation === 'horizontal' ? 'flex-start' : 'flex-end'};
  border-block-end: 1px solid ${theme.colors.borderLight};
  border-inline-start: 1px solid ${theme.colors.borderLight};
  border-inline-end: ${({ $bothAxes }) =>
    $bothAxes ? `1px solid ${theme.colors.borderLight}` : 'none'};
  display: ${({ $chartType }) => ($chartType === 'scatter' ? 'block' : 'flex')};
  flex-direction: ${({ $barOrientation }) =>
    $barOrientation === 'horizontal' ? 'column' : 'row'};
  gap: 5%;
  flex-grow: 1;
  height: 100%;
  overflow: clip;
  padding: ${theme.spacing.lg};
  position: relative;
`;
